<template>
    <div class="container-fluid mt-7">
        <div class="card">
            <base-header class="pb-6" type="">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 d-inline-block mb-0">Sales</h6>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-2 col-md-3 col-md-card col-width">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                                    {{ usersCount }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white">USERS</h4>
                                <p class="mb-0 opacity-8 text-white h6">Total active users</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-2 col-md-3 col-md-card col-width">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                                    {{ brokersCount }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Brokers</h4>
                                <p class="mb-0 opacity-8 text-white h6">Total active brokers</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-2 col-md-3 col-md-card col-width">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                                    {{ instrumentsCount }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Instruments</h4>
                                <p class="mb-0 opacity-8 text-white h6">Total instruments in today's order</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-2 col-md-3 col-md-card col-width">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                                    {{ ordersCount }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Today's Orders</h4>
                                <p class="mb-0 opacity-8 text-white h6">Total today's orders</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-2 col-md-3 col-md-card col-width">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                                    {{ strategiesCount }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Strategies</h4>
                                <p class="mb-0 opacity-8 text-white h6">Total active strategies</p>
                            </div>
                        </div>
                    </div>
                </div>
            </base-header>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            brokersCount: "",
            usersCount: "",
            instrumentsCount: "",
            strategiesCount: "",
            ordersCount: "",
        };
    },
    methods: {
        getBrokersCount(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("salesStore/getSalesData", data, { root: true })
                .then(response => {
                    this.brokersCount = response.server.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getUsersCount(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("salesStore/getSalesData", data, { root: true })
                .then(response => {
                    this.usersCount = response.server.data;
                })
                .catch(error => {
                });
        },
        getInstrumentsCount(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("salesStore/getSalesData", data, { root: true })
                .then(response => {
                    this.instrumentsCount = response.server.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getStrategiesCount() {
            let data = {
                type: 'portfolio-name'
            };
            if (sessionStorage.getItem(data.type + "-reference-data")) {
                this.strategiesCount = JSON.parse(sessionStorage.getItem(data.type + "-reference-data")).length
            } else {
                this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
                    .then(response => {
                        this.strategiesCount = response.server.data.length;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        getTodaysOrderCount(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("salesStore/getSalesData", data, { root: true })
                .then(response => {
                    this.ordersCount = response.server.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },
    mounted() {
        this.getBrokersCount("broker");
        this.getUsersCount("user");
        this.getInstrumentsCount("instrument");
        this.getStrategiesCount("portfolio");
        this.getTodaysOrderCount("order");
    },
};
</script>
